var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.canCreateClients)?_c('ResponsiveIconButton',{staticClass:"ma-0",staticStyle:{"height":"56px"},attrs:{"icon":"add","buttonText":"Neuen Mandanten erstellen","tooltipText":"Neuen Mandanten erstellen","tooltipWidth":200},on:{"click":function($event){return _vm.goToNewClientPage()}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }